// extracted by mini-css-extract-plugin
export default {"header-link-block":"SocialLinksBlock_header-link-block__DLqTS","footer-link-block":"SocialLinksBlock_footer-link-block__OTGIK","idCrown":"SocialLinksBlock_idCrown__Tlwhr"};